<template>
    <v-card class="dt-modal">
      <div class="box-widget selected">
        <div class="box-header gray">
          <div class="box-header--name">
            <!-- <span style="margin-right: 8px;" >To</span> -->
            <span style="font-weight: 800">{{mailData.email1}}</span>
          </div>
          <div class="box-header--options">
            <span style="margin-right: 8px;margin-top: 5px; font-weight: 500" >{{$t('subject')}}</span>
            <input type="text" class="dt-textbox subject-textbox" v-model="mailSubject" >
          </div>
        </div>
        <div class="box-body">
          <div class="dbox-textarea-container">
            <textarea name="deal" id="deal" v-model="mailText"></textarea>
          </div> 
        </div>
      </div>
      <div class="dt-modal--options">
          <button class="dt-button v1 s1" @click="onSubmit" >
              {{$t('submit')}}
          </button>
          <button class="dt-button s1" @click="onCancel">
              {{$t('cancel')}}
          </button>    
      </div>
    </v-card>
</template>

<script>
import * as R from 'ramda';

export default {
  props: {
    mailData: {
      type: Object,
    }
  },
  data: function() {
    return {
      mailText: '',
      mailSubject: ''
    }
  },
  watch: {
    mailData: {
      immediate: true,
      handler: function(newValue, oldValue) {
        this.mailText = getMailBody(newValue) ? getMailBody(newValue) : '';
        this.mailSubject = newValue.document && newValue.document.subject || '';
      }
    }
  },
  computed: {

  },
  methods: {
    onBlur: function(event) {

    },
    onSubmit: function(event) {
      this.$emit('submit', {
        mailText: this.mailText,
        mailSubject: this.mailSubject,
        mailData: this.mailData
      });
    },
    onCancel: function(event) {
      this.$emit('cancel', true);
    }
  }
}

const getMailBody = ({
  client_display_name,
  document = { subject: '' }
}) => {
  return `Dear Promoter, 
${client_display_name} has just added a contract to be signed in the Details Promoter App.  Please login to review and sign this contract:

${document.subject}`;

}

</script>

<style lang="scss" scoped>

  .dbox-textarea-container {
    height: 160px;
  }

  .box-widget {
    padding: 10px;
  }

  .box-header--options {
    width: 350px;
    border-left: 1px solid transparent;
  }

  .subject-textbox {
    // background: var(--sprt-4);
    // color: white;
    // border-radius: 2px;
    background: white;
    padding: 5px;
  }

</style>
